<template>
  <div id="form" v-if="loadingSchoolForm">
    <div
      class="groupForm"
      @click="clickAreaFn($event)"
      v-if="selectGroup != 2"
      key="map"
    >
      <div class="form_item">
        <div class="col">
          <label for="group">
            <i>*</i>
            参赛赛组：
          </label>
          <div class="input" @click="showPopup('group1')">
            <template>
              <p class="placeholder" v-if="!mapForm.group">
                请选择赛组
              </p>
              <p class="select-div" v-else>
                游戏制作组
              </p>
            </template>

            <van-popup
              v-model="showGroupPop1"
              position="bottom"
              :style="{ height: '45%' }"
            >
              <van-picker
                show-toolbar
                value-key="name"
                :columns="groupArr"
                @confirm="confirmGroupPop1"
              />
            </van-popup>
          </div>
        </div>
        <span
          class="error-txt"
          v-if="mapErrors.fields && mapErrors.fields.group"
          >{{ mapErrors.fields.group[0].message }}</span
        >
      </div>
      <div class="form_item">
        <div class="col">
          <label for="works">
            <i>*</i>
            选择作品：
          </label>
          <template>
            <div v-if="hasMapWorks" class="input" @click="showPopup('works')">
              <template>
                <p class="placeholder" v-if="!mapForm.works">
                  请选择作品
                </p>
                <p class="select-div" v-else>
                  {{ mapWorksValue.name }}
                </p>
              </template>

              <van-popup
                v-model="showWorksPop"
                position="bottom"
                :style="{ height: '45%' }"
              >
                <van-picker
                  show-toolbar
                  value-key="name"
                  :columns="mapWorksArr"
                  @confirm="confirmWorksPop"
                />
              </van-popup>
            </div>

            <div v-else class="no-work-txt">
              <p class="small-txt orange-txt">你还没有可参赛的作品。</p>
              <p class="small-txt orange-txt">
                赶紧到游戏内创建并分享吧！
              </p>
            </div>
          </template>
        </div>
        <span
          class="error-txt"
          v-if="mapErrors.fields && mapErrors.fields.works"
          >{{ mapErrors.fields.works[0].message }}</span
        >
      </div>

      <p v-if="!hasNcdaMapWorkInfo && !isPerson" class="no-ncda-work">
        请先前往NCDA大赛官网提交该赛组的作品信息，再回本页面选择作品完成投稿
      </p>
      <template v-else>
        <template v-if="isPerson && hasMapWorks">
          <div class="form_item">
            <div class="col">
              <label for="cover">
                <i>*</i>
                作品封面：
              </label>
              <div class="cover-box">
                <div class="input img">
                  <p class="placeholder img">
                    为作品上传一张封面
                  </p>
                  <div @click="openFileSingle">
                    +
                  </div>
                </div>
                <div class="imgs-box">
                  <div class="close-img" v-if="mapCoverSrc">
                    <img
                      :src="mapCoverSrc"
                      class="upload-img"
                      @click="bigImgFn(mapCoverSrc)"
                    />
                    <div
                      class="close-btn"
                      @click="removeMapCover"
                      v-if="mapCoverSrc"
                    >
                      x
                    </div>
                  </div>
                </div>
                <span
                  class="cover-error"
                  v-if="mapErrors.fields && mapErrors.fields.cover"
                  >{{ mapErrors.fields.cover[0].message }}</span
                >
              </div>
            </div>
          </div>
          <div class="form_item textarea">
            <div class="col">
              <label for="intro">
                <i>*</i>
                作品介绍：
              </label>
              <textarea
                :disabled="!isLogin || !hasMapWorks"
                name="intro"
                id="intro"
                v-model="mapForm.intro"
                placeholder="请输入你的作品介绍，不超过500个字"
              ></textarea>
            </div>
            <span
              class="error-txt"
              v-if="mapErrors.fields && mapErrors.fields.intro"
              >{{ mapErrors.fields.intro[0].message }}</span
            >
          </div>
          <div class="form_item textarea">
            <div class="col">
              <label for="context">
                <i>*</i>
                玩法说明：
              </label>
              <textarea
                :disabled="!isLogin || !hasMapWorks"
                name="context"
                id="context"
                v-model="mapForm.context"
                placeholder="介绍游戏的玩法、特色、攻略，便于评委快 速体验游戏，不超过500字"
              ></textarea>
            </div>
            <span
              class="error-txt"
              v-if="mapErrors.fields && mapErrors.fields.context"
              >{{ mapErrors.fields.context[0].message }}</span
            >
          </div>
          <div class="form_item screenshot">
            <div class="col">
              <label for="imgs">
                <i>*</i>
                作品截图：
              </label>
              <div class="cover-box">
                <div class="input img">
                  <p class="placeholder img">
                    请上传2-8张作品相关截图
                  </p>
                  <div @click="openFileMultipleMap">+</div>
                </div>
                <div class="imgs-box">
                  <div
                    class="close-img more"
                    v-for="(img, i) in mapImgsSrc"
                    :key="i"
                  >
                    <img
                      v-if="img"
                      :src="img"
                      class="upload-img"
                      @click="bigImgFn(img)"
                    />
                    <div
                      class="close-btn"
                      @click="removeImgs(i, 'map')"
                      v-if="img"
                    >
                      x
                    </div>
                  </div>
                </div>
                <span
                  class="cover-error"
                  v-if="mapErrors.fields && mapErrors.fields.imgs"
                  >{{ mapErrors.fields.imgs[0].message }}</span
                >
              </div>
            </div>
          </div>
          <div class="form_item">
            <div class="col">
              <label for="videoUrl">
                演示视频：
              </label>
              <input
                :disabled="!isLogin || !hasMapWorks"
                class="input"
                id="videoUrl"
                type="text"
                name="videoUrl"
                v-model="mapForm.videoUrl"
                placeholder="可上传一段介绍作品的视频地址"
              />
            </div>
            <span
              class="error-txt"
              v-if="mapErrors.fields && mapErrors.fields.videoUrl"
              >{{ mapErrors.fields.videoUrl[0].message }}</span
            >
          </div>
        </template>
        <template v-if="!isPerson && hasMapWorks">
          <div class="form_item">
            <div class="col">
              <label for="cover">
                作品封面：
              </label>
              <div class="cover-box">
                <div class="imgs-box">
                  <div class="close-img">
                    <img
                      :src="mapCoverSrc"
                      class="upload-img"
                      @click="bigImgFn(mapCoverSrc)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form_item">
            <div class="col">
              <label for="intro">
                作品介绍：
              </label>
              <div class="input-school-txt">
                {{ mapForm.intro }}
              </div>
            </div>
          </div>
          <div class="form_item">
            <div class="col">
              <label for="intro">
                玩法说明：
              </label>
              <div class="input-school-txt">{{ mapForm.context }}</div>
            </div>
          </div>
          <div class="form_item screenshot">
            <div class="col">
              <label for="imgs">
                作品截图：
              </label>
              <div class="cover-box">
                <div class="imgs-box">
                  <div
                    class="close-img more"
                    v-for="(img, i) in mapImgsSrc"
                    :key="i"
                  >
                    <img
                      v-if="img"
                      :src="img"
                      class="upload-img"
                      @click="bigImgFn(img)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form_item">
            <div class="col">
              <label for="intro">
                演示视频：
              </label>
              <div class="input-school-txt">{{ mapForm.videoUrl }}</div>
            </div>
          </div>
        </template>
        <button
          class="btn-apply orange"
          @click="submitApplyMap"
          v-if="hasMapWorks"
        >
          {{ mapBtnTxt }}
        </button>
      </template>
    </div>
    <div class="groupForm" v-else key="good" @click="clickAreaFn($event)">
      <div class="form_item">
        <div class="col">
          <label for="group">
            <i>*</i>
            选择赛组：
          </label>
          <div class="input" @click="showPopup('group2')">
            <template>
              <p class="placeholder" v-if="!goodForm.group">
                请选择赛组
              </p>
              <p class="select-div" v-else>
                模型制作组
              </p>
            </template>

            <van-popup
              v-model="showGroupPop2"
              position="bottom"
              :style="{ height: '45%' }"
            >
              <van-picker
                show-toolbar
                value-key="name"
                :columns="groupArr"
                @confirm="confirmGroupPop2"
              />
            </van-popup>
          </div>
        </div>
        <span
          class="error-txt"
          v-if="mapErrors.fields && mapErrors.fields.group"
          >{{ mapErrors.fields.group[0].message }}</span
        >
      </div>
      <div class="form_item">
        <div class="col">
          <label for="works">
            <i>*</i>
            选择作品：
          </label>
          <template>
            <div v-if="!hasGoodWorks" class="no-work-txt">
              <p class="small-txt orange-txt">你还没有可参赛的作品。</p>
              <p class="small-txt orange-txt">
                赶紧到游戏内创建并分享吧
              </p>
            </div>
            <div v-else>
              <div class="goodWork" v-for="(good, g) in goodWorksArr" :key="g">
                <div class="game-good">
                  <img
                    :src="good.cover"
                    @click="radio(good.id, g)"
                    :class="selectImg === g ? 'select-css' : ''"
                  />

                  <div class="good-txt-box">
                    <p>{{ good.name }}</p>
                    <p>类型：模型</p>
                    <p v-if="good.tags">标签：{{ good.tags | getTags }}</p>
                    <p v-if="good.size">大小：{{ good.size | getSize }}</p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="form_item" v-if="hasGoodWorks">
        <div class="col">
          <label for="works">
            <i>*</i>
            资源：
          </label>
          <img
            class="smallGoodsImg"
            v-for="(small, s) in smallImgArr[smallIndex]"
            :key="s"
            :src="small"
          />
        </div>
      </div>
      <p v-if="!hasNcdaGoodWorkInfo && !isPerson" class="no-ncda-work">
        请先前往NCDA大赛官网提交该赛组的作品信息，再回本页面选择作品完成投稿
      </p>
      <template v-else>
        <template v-if="isPerson && hasGoodWorks">
          <div class="form_item textarea">
            <div class="col">
              <label for="intro">
                <i>*</i>
                作品介绍：
              </label>
              <textarea
                :disabled="!isLogin || !hasGoodWorks"
                name="intro"
                id="intro"
                v-model="goodForm.intro"
                placeholder="请输入你的作品介绍，不超过500个字"
              ></textarea>
            </div>
            <span
              class="error-txt"
              v-if="goodErrors.fields && goodErrors.fields.intro"
              >{{ goodErrors.fields.intro[0].message }}</span
            >
          </div>
          <div class="form_item screenshot">
            <div class="col">
              <label for="cover">
                <i>*</i>
                作品截图：
              </label>
              <div class="cover-box">
                <div class="input img">
                  <p class="placeholder img">
                    请上传2-8张作品相关截图
                  </p>
                  <div @click="openFileMultipleGood">+</div>
                </div>
                <div class="imgs-box">
                  <div
                    class="close-img more"
                    v-for="(img, i) in goodImgsSrc"
                    :key="i"
                  >
                    <img
                      v-if="img"
                      :src="img"
                      class="upload-img"
                      @click="bigImgFn(img)"
                    />
                    <div
                      class="close-btn"
                      @click="removeImgs(i, 'good')"
                      v-if="img"
                    >
                      x
                    </div>
                  </div>
                </div>
                <span
                  class="cover-error"
                  v-if="goodErrors.fields && goodErrors.fields.imgs"
                  >{{ goodErrors.fields.imgs[0].message }}</span
                >
              </div>
            </div>
          </div>
        </template>
        <template v-if="!isPerson && hasGoodWorks">
          <div class="form_item">
            <div class="col">
              <label for="intro">
                <i>*</i>
                作品介绍：
              </label>
              <div class="input-school-txt">
                {{ goodForm.intro }}
              </div>
            </div>
          </div>
          <div class="form_item screenshot">
            <div class="col">
              <label for="cover">
                <i>*</i>
                作品截图：
              </label>
              <div class="cover-box">
                <div class="imgs-box">
                  <div
                    class="close-img more"
                    v-for="(img, i) in goodImgsSrc"
                    :key="i"
                  >
                    <img
                      v-if="img"
                      :src="img"
                      class="upload-img"
                      @click="bigImgFn(img)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <button
          class="btn-apply orange"
          @click="submitApplyRes"
          v-if="hasGoodWorks"
        >
          {{ goodBtnTxt }}
        </button>
      </template>
    </div>

    <van-loading v-if="loading" class="img-loading" type="spinner" size="30">{{
      loadingTxt
    }}</van-loading>
    <input
      class="uploadImg"
      @change="selectCover"
      type="file"
      accept="image/jpg,image/png"
      ref="mapCover"
    />
    <input
      class="uploadImg"
      multiple
      @change="selectMapImgs"
      type="file"
      accept="image/jpg,image/png"
      ref="mapImgs"
    />
    <input
      class="uploadImg"
      multiple
      @change="selectGoodImgs"
      type="file"
      accept="image/jpg,image/png"
      ref="goodImgs"
    />
  </div>
</template>
<script>
import { ImagePreview } from 'vant';
import { baseUrl } from '../api/baseUrl';
import AsyncValidator from 'async-validator';

import ajax from '../api/ajax';
import { uploadUrl } from '../common/uploadUrl';
import { seasonId, divisionIdM, divisionIdG } from '../common/argumentId';
export default {
  name: 'ContributeForm',
  props: {
    isLogin: {
      type: Boolean
    }
  },
  data() {
    return {
      pass: false,
      loadingTxt: '加载中...',
      mapCoverSrc: '',
      mapImgsSrc: [],
      goodImgsSrc: [],
      loading: false,
      hasMapApply: false, // 是否有投过稿
      hasGoodApply: false,
      mapBtnTxt: '修改投稿',
      goodBtnTxt: '提交投稿',
      selectImg: 0, // 默认选中资源1大图
      smallImgArr: [], // 资源小图数组
      smallIndex: 0, // 展示大图对应的小图们
      hasMapWorks: false, // 是否有地图作品
      hasGoodWorks: false, // 是否有资源作品
      selectGroup: '', // 是否选中某赛组
      mapImgsFile: [],
      goodImgsFile: [],
      showWorksPop: false,
      showGroupPop1: false,
      showGroupPop2: false,
      // 地图作品数组
      mapWorksArr: [],
      // 资源作品数组
      goodWorksArr: [],
      // 赛组数组
      groupArr: [
        { id: 1, name: '游戏制作组' },
        { id: 2, name: '模型制作组' }
      ],
      groupValue1: { name: '游戏制作组', id: 1 }, // 选中的赛组
      groupValue2: { name: '模型制作组', id: 2 }, // 选中的赛组
      mapWorksValue: {}, // 选中的地图作品
      // 地图表单
      mapForm: {
        group: 1, // 组别
        works: '', // 作品
        cover: [], // 封面
        intro: '', // 介绍
        context: '', // 说明
        imgs: '', //截图
        videoUrl: ''
      },
      // 资源表单
      goodForm: {
        group: 2, // 组别
        intro: '', // 介绍
        imgs: '' //截图
      },
      mapErrors: {}, // 地图错误提示
      goodErrors: {}, // 资源错误提示
      // 地图规则
      mapRules: {
        group: {
          validator: (rule, value, callback) => {
            if (value == null || !String(value)) return callback(`请选择赛组`);
            callback();
          }
        },
        works: {
          validator: (rule, value, callback) => {
            if (value == null || !String(value)) return callback(`请选择作品`);
            callback();
          }
        },
        cover: {
          validator: (rule, value, callback) => {
            if (value == null || !String(value))
              return callback(`请上传一张作品封面`);
            callback();
          }
        },
        intro: {
          validator: (rule, value, callback) => {
            if (value == null || !String(value))
              return callback(`请输入作品介绍`);
            callback();
          }
        },
        context: {
          validator: (rule, value, callback) => {
            if (value == null || !String(value))
              return callback(`请输入玩法说明`);
            callback();
          }
        },
        imgs: {
          validator: (rule, value, callback) => {
            if (value == null || value.split(',').length < 2) {
              return callback(`请至少上传2张作品截图`);
            } else {
              callback();
            }
          }
        },
        videoUrl: {
          validator: (rule, value, callback) => {
            const reg = /(http|https):\/\/([\w.]+\/?)\S*/;
            if (value) {
              reg.test(value) ? callback() : callback(`请输入正确的视频连接`);
            } else {
              callback();
            }
          }
        }
      },
      // 资源规则
      goodRules: {
        group: {
          validator: (rule, value, callback) => {
            if (value == null || !String(value)) return callback(`请选择赛组`);
            callback();
          }
        },
        intro: {
          validator: (rule, value, callback) => {
            if (value == null || !String(value))
              return callback(`请输入作品介绍`);
            callback();
          }
        },
        imgs: {
          validator: (rule, value, callback) => {
            if (value == null || value.split(',').length < 2) {
              return callback(`请至少上传2张作品截图`);
            } else {
              callback();
            }
          }
        }
      },
      loadingSchoolForm: false,
      hasNcdaMapWorkInfo: false,
      hasNcdaGoodWorkInfo: false
    };
  },
  mounted() {
    if (this.$route.path == '/works/2') {
      this.$bus.$on('works', works => {
        if (works) {
          if (works['50']) {
            this.hasNcdaMapWorkInfo = true;
            let data = works['50'];
            // 地图有信息
            if (data.wid) {
              console.log(this.mapWorksArr);
              console.log(data.mapId);
              this.mapWorksArr.forEach(item => {
                if (item.id == data.mapId) {
                  console.log(item);
                  this.mapForm.works = item.id;
                  this.mapWorksValue = {
                    name: item.name,
                    id: item.id
                  };
                } else {
                  this.mapForm.works = data.mapId;
                  this.mapWorksValue = {
                    name: data.mapId,
                    id: data.mapId
                  };
                }
              });
              this.goodBtnTxt = '修改投稿';
              this.hasMapApply = true;
            } else {
              this.mapBtnTxt = '提交投稿';
            }
            this.mapForm.group = 1;
            this.mapForm.cover = data.cover;
            this.mapCoverSrc = data.cover;
            this.mapForm.intro = data.intro;
            this.mapForm.context = data.context;
            if (data.imgs.endsWith(',')) {
              let newImg = data.imgs.substring(0, data.imgs.length - 1);
              this.mapForm.imgs = newImg;
              this.mapImgsSrc = newImg.split(',');
            } else {
              this.mapForm.imgs = data.imgs;
              this.mapImgsSrc = data.imgs.split(',');
            }

            this.mapForm.videoUrl = data.videoUrl;
            this.mapForm.wid = data.wid;
          } else {
            this.hasNcdaMapWorkInfo = false;
          }
          // 资源
          if (works['60']) {
            this.hasNcdaGoodWorkInfo = true;
            let data = works['60'];
            if (data.imgs != null) {
              this.goodImgsSrc = data.imgs.split(',');
              if (data.imgs.endsWith(',')) {
                let newImg = data.imgs.substring(0, data.imgs.length - 1);
                this.goodForm.imgs = newImg;
                this.goodImgsSrc = newImg.split(',');
              } else {
                this.goodForm.imgs = data.imgs;
                this.goodImgsSrc = data.imgs.split(',');
              }
            }
            this.goodForm.group = 2;
            this.goodForm.intro = data.intro;
            this.goodForm.wid = data.wid;
            this.goodForm.ncdaCover = data.cover;
            if (data.wid) {
              this.goodBtnTxt = '修改投稿';
              this.hasGoodApply = true;
            } else {
              this.mapBtnTxt = '提交投稿';
            }
          } else {
            this.hasNcdaGoodWorkInfo = false;
          }
        } else {
          this.mapBtnTxt = '提交投稿';
        }
        this.loadingSchoolForm = true;
      });
    }

    if (this.isLogin) {
      this.loadingSchoolForm = true;
      this.queryMap();
      this.queryGoods();
      if (this.$route.path == '/works/1') {
        this.queryHasMap();
        this.queryHasGood();
      }
    }
  },
  computed: {
    isPerson() {
      return window.location.hash.split('#')[1] === '/works/1' ? true : false;
    }
  },
  watch: {
    isLogin: function(val) {
      if (val) {
        this.loadingSchoolForm = true;
        this.queryMap();
        this.queryGoods();
        if (this.$route.path == '/works/1') {
          this.queryHasMap();
          this.queryHasGood();
        }
      } else {
        Object.assign(this.$data, this.$options.data());
      }
    }
  },

  methods: {
    //  查是否有投稿地图
    async queryHasMap() {
      try {
        this.loading = true;
        const res = await this.$http.apiHasWork({
          seasonId,
          divisionId: divisionIdM
        });
        if (res.data.code != 0) {
          this.$Toast(res.data.msg);
        } else {
          const { data } = res.data;
          this.loading = false;

          if (data && data.wid != null) {
            this.mapForm.group = 1;
            this.mapForm.works = data.mapId;
            this.mapWorksValue = {
              name: data.name,
              id: data.mapId
            };
            this.mapForm.cover = data.cover;
            this.mapCoverSrc = data.cover;
            this.mapForm.intro = data.intro;
            this.mapForm.context = data.context;
            this.mapForm.imgs = data.imgs;
            this.mapImgsSrc = data.imgs.split(',');
            this.mapForm.videoUrl = data.videoUrl;
            this.mapForm.wid = data.wid;
            this.mapBtnTxt = '修改投稿';
            this.hasMapApply = true;
          } else {
            this.mapBtnTxt = '提交投稿';
          }
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async queryHasGood() {
      // 是否有资源投稿
      try {
        this.loading = true;
        const res = await this.$http.apiHasWork({
          seasonId,
          divisionId: divisionIdG
        });
        if (res.data.code != 0) {
          this.$Toast(res.data.msg);
        } else {
          const { data } = res.data;
          this.loading = false;

          if (data && data.wid != null) {
            this.goodForm.imgs = data.imgs;
            if (data.imgs != null) {
              this.goodImgsSrc = data.imgs.split(',');
            }
            this.goodForm.group = 2;
            this.goodForm.intro = data.intro;
            this.goodForm.wid = data.wid;
            this.goodBtnTxt = '修改投稿';
            this.hasGoodApply = true;
          } else {
            this.goodBtnTxt = '提交投稿';
          }
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 切换选中的资源
    radio(id, index) {
      this.smallIndex = index;
      this.selectImg = index;
    },
    // 查询地图
    async queryMap() {
      try {
        this.loading = true;
        const res = await this.$http.apiMap({
          seasonId: seasonId,
          divisionId: divisionIdM
        });

        if (res.data.code != 0) {
          this.$Toast(res.data.msg);
        } else {
          const { data } = res.data;
          if (data && data.length) {
            this.hasMapWorks = true;
            this.mapWorksArr = data;
          } else {
            this.hasMapWorks = false;
          }
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 查询资源
    async queryGoods() {
      this.smallImgArr = [];
      try {
        this.loading = true;
        const res = await this.$http.apiGoods({
          seasonId: seasonId,
          divisionId: divisionIdG
        });
        if (res.data.code != 0) {
          this.$Toast(res.data.msg);
        } else {
          const { data } = res.data;
          this.loading = false;
          if (data && data.length) {
            this.hasGoodWorks = true;
            this.goodWorksArr = data;
            data.forEach(item => {
              this.smallImgArr.push(item.itemCovers.split(','));
            });
          } else {
            this.hasGoodWorks = false;
          }
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 验证提交地图
    async submitApplyMap() {
      if (this.isLogin) {
        if (this.hasMapWorks) {
          this.mapErrors = await new AsyncValidator(this.mapRules)
            .validate(this.mapForm)
            .catch(e => e);
          if (this.mapErrors) {
            return;
          } else {
            let opt = '';
            this.hasMapApply ? (opt = 'update') : (opt = 'add');
            let body = {
              works: {
                name: this.mapWorksValue.name,
                mapId: this.mapWorksValue.id,
                cover: this.mapForm.cover,
                intro: this.mapForm.intro,
                context: this.mapForm.context,
                imgs: this.mapForm.imgs,
                terminal: 'mobile',
                channelId: '-1',
                langId: '0',
                typeId: '16'
              }
            };
            if (this.mapForm.videoUrl) {
              Object.assign(body.works, { videoUrl: this.mapForm.videoUrl });
            }
            if (this.mapForm.wid) {
              Object.assign(body.works, { wid: this.mapForm.wid });
            }
            this.submitFn(seasonId, divisionIdM, opt, body);
          }
          this.mapErrors = {};
        } else {
          this.$Toast('你还没有可参赛的作品，赶紧到游戏内创建并分享吧！');
        }
      } else {
        this.$Toast('请先登录');
      }
    },
    // 验证提交资源
    async submitApplyRes() {
      if (this.isLogin) {
        if (this.hasGoodWorks) {
          this.goodErrors = await new AsyncValidator(this.goodRules)
            .validate(this.goodForm)
            .catch(e => e);
          if (this.goodErrors) {
            return;
          } else {
            let opt = '';
            this.hasGoodApply ? (opt = 'update') : (opt = 'add');
            let body = {
              works: {
                name: this.goodWorksArr[this.smallIndex].name,
                mapId: this.goodWorksArr[this.smallIndex].id,
                intro: this.goodForm.intro,
                cover: this.goodWorksArr[this.smallIndex].cover,
                itemCovers: this.goodWorksArr[this.smallIndex].itemCovers,
                imgs: this.goodForm.imgs,
                terminal: 'mobile',
                channelId: '-1',
                langId: '0',
                typeId: '17',
                tags: this.goodWorksArr[this.smallIndex].tags || '',
                costNum: this.goodForm.costNum || 0
              }
            };
            if (this.goodForm.wid) {
              Object.assign(body.works, { wid: this.goodForm.wid });
            }
            this.submitFn(seasonId, divisionIdG, opt, body);
          }
          this.goodErrors = {};
        } else {
          this.$Toast('你还没有可参赛的作品，赶紧到游戏内创建并分享吧！');
        }
      } else {
        this.$Toast('请先登录');
      }
    },
    // 提交投稿
    async submitFn(SID, DID, opt, body) {
      try {
        this.loading = true;
        const res = await ajax.post(
          `${baseUrl}/pu/v1/works?seasonId=${SID}&divisionId=${DID}&opt=${opt}`,
          body
        );
        this.loading = false;
        this.$Toast(res.data.msg);
        if (res.data.msg != '请不要频繁投稿' && res.data.code != 151) {
          if (this.selectGroup != 2) {
            this.queryHasMap();
          } else {
            this.queryHasGood();
          }
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 显示选择面板
    showPopup(val) {
      if (this.isLogin) {
        if (val === 'works') {
          this.showWorksPop = true;
        } else if (val === 'group1') {
          this.showGroupPop1 = true;
        } else if (val === 'group2') {
          this.showGroupPop2 = true;
        }
      } else {
        return false;
      }
    },
    // 关闭面板
    clickAreaFn(e) {
      let targets1 = 'van-picker__confirm'; // 确认
      let targets2 = 'van-picker__cancel'; // 取消
      let targets3 = 'van-overlay van-fade-enter van-fade-enter-active'; // 面板外
      if (
        e.target.className == targets1 ||
        e.target.className == targets2 ||
        e.target.className == targets3
      ) {
        this.showWorksPop = false;
        this.showGroupPop1 = false;
        this.showGroupPop2 = false;
      }
    },
    // 确认组别选择
    confirmGroupPop1(val) {
      this.selectGroup = val.id;
      this.mapForm.group = val.id;
      this.groupValue1 = {
        name: val.name,
        id: val.id
      };
    },
    // 确认组别选择
    confirmGroupPop2(val) {
      this.selectGroup = val.id;
      this.goodForm.group = val.id;
      this.groupValue2 = {
        name: val.name,
        id: val.id
      };
    },
    // 确认地图作品选择
    confirmWorksPop(val) {
      this.mapForm.works = val.name;
      this.mapWorksValue = {
        name: val.name,
        id: val.id
      };
    },
    openFileSingle() {
      if (this.isLogin) {
        this.$refs.mapCover.click();
      }
    },
    selectCover() {
      this.loading = true;
      this.loadingTxt = '上传中...';
      let coverFile = this.$refs.mapCover.files[0];
      const isLt2M = coverFile.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$Toast('请上传小于 2MB 图片!');
        return false;
      } else {
        let formdata = new FormData();
        formdata.append('platform', 'school');
        formdata.append('token', 'C02XEWRDC7QX7ABEYL87BP881A3QZV09');
        formdata.append('mapCover', coverFile);
        ajax
          .post(uploadUrl, formdata, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(res => {
            this.mapCoverSrc = res.data.data.mapCover.cdn_url;
            this.mapForm.cover = this.mapCoverSrc;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.$Toast('上传失败');
          });
      }
    },
    openFileMultipleMap() {
      if (this.isLogin) {
        this.$refs.mapImgs.click();
      }
    },
    selectMapImgs() {
      let mapImgsFile = this.$refs.mapImgs.files;
      let length = this.mapImgsSrc.length + mapImgsFile.length;
      mapImgsFile.forEach(item => {
        if (item.size / 1024 / 1024 > 2) {
          this.$Toast('每张图片需小于 2MB!');
          this.pass = false;
        } else {
          this.pass = true;
        }
      });
      if (length > 8) {
        this.$Toast('请上传少于8张图片');
      } else if (this.pass == true) {
        this.loading = true;
        this.loadingTxt = '上传中...';
        let formdata = new FormData();
        formdata.append('platform', 'school');
        formdata.append('token', 'C02XEWRDC7QX7ABEYL87BP881A3QZV09');
        mapImgsFile.forEach((item, i) => {
          formdata.append(`mapImgs[${i}]`, item);
        });

        ajax
          .post(uploadUrl, formdata, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(res => {
            res.data.data.mapImgs.forEach(item => {
              this.mapImgsSrc.push(item.cdn_url);
            });
            this.mapForm.imgs = this.mapImgsSrc.join(',');
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.$Toast('上传失败');
          });
      }
    },
    openFileMultipleGood() {
      this.$refs.goodImgs.click();
    },
    selectGoodImgs() {
      let goodImgsFile = this.$refs.goodImgs.files;
      let length = this.goodImgsSrc.length + goodImgsFile.length;
      goodImgsFile.forEach(item => {
        if (item.size / 1024 / 1024 > 2) {
          this.$Toast('每张图片需小于 2MB!');
          this.pass = false;
        } else {
          this.pass = true;
        }
      });
      if (length > 8) {
        this.$Toast('请上传少于8张图片');
      } else if (this.pass == true) {
        this.loading = true;
        this.loadingTxt = '上传中...';
        let formdata = new FormData();
        formdata.append('platform', 'school');
        formdata.append('token', 'C02XEWRDC7QX7ABEYL87BP881A3QZV09');
        goodImgsFile.forEach((item, i) => {
          formdata.append(`goodImgs[${i}]`, item);
        });
        ajax
          .post(uploadUrl, formdata, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(res => {
            res.data.data.goodImgs.forEach(item => {
              this.goodImgsSrc.push(item.cdn_url);
            });
            this.goodForm.imgs = this.goodImgsSrc.join(',');
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.$Toast('上传失败');
          });
      }
    },
    removeMapCover() {
      this.mapCoverSrc = '';
      this.mapForm.cover = '';
    },
    removeImgs(i, type) {
      if (type == 'map') {
        this.mapImgsSrc.splice(i, 1);
        this.mapForm.imgs = this.mapImgsSrc.join(',');
      } else {
        this.goodImgsSrc.splice(i, 1);
        this.goodForm.imgs = this.goodImgsSrc.join(',');
      }
    },
    bigImgFn(val) {
      ImagePreview({
        images: [val],
        showIndex: false
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#form {
  width: 750px;
  position: relative;
}
.groupForm {
  position: relative;
  width: 750px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-size: 32px;

  .form_item {
    width: 620px;
    margin-bottom: 10px;

    i {
      color: red;
      margin-right: 10px;
    }
    .col {
      display: flex;
      label {
        width: 200px;
        display: flex;
        justify-content: flex-end;
      }
    }

    .input-school-txt {
      width: 420px;
      word-wrap: break-word;
    }

    .input,
    textarea {
      height: 60px;
      width: 420px;
      border-radius: 4px;
      outline: none;
      background: #eeeeee;
      text-indent: 20px;
      border: 1px solid #000;

      // 选中省市
      .select-div {
        line-height: 60px;
      }
    }
    .no-work-txt {
      width: 420px;
    }
  }
  .form_item.textarea {
    height: 290px;
    textarea {
      text-indent: 0;
      height: 250px;
      padding: 0 10px 0 20px;
    }
  }

  .screenshot {
    // width: 680px;
    margin-bottom: 10px;
    i {
      color: red;
      margin-right: 10px;
    }
    .col {
      display: flex;
      label {
        width: 200px;
        display: flex;
        justify-content: flex-end;
      }
    }
    .cover {
      width: 420px;
      display: flex;
      flex-direction: column;
    }
  }

  .icon-search {
    position: absolute;
    right: 75px;
    width: 40px;
    height: 40px;
    margin-top: 10px;
  }
  .error-txt,
  .cover-error {
    color: red;
    font-size: 24px;
  }
  .error-txt {
    margin-left: 200px;
  }
}

// div的placeholder
.input:empty::before {
  line-height: 60px;
  color: #ccc;
  content: attr(placeholder);
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #b3b3b3;
  font-size: 28px;
}
input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #b3b3b3;
  font-size: 28px;
}
input::-moz-placeholder,
textarea::-moz-placeholder {
  color: #b3b3b3;
  font-size: 28px;
}
input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #b3b3b3;
  font-size: 28px;
}

.placeholder {
  line-height: 60px;
  color: #ccc;
}

/deep/ .van-picker-column,
/deep/ .van-picker__cancel,
/deep/ .van-picker__title,
/deep/ .van-picker__confirm {
  font-size: 34px;
}
/deep/ .van-picker__toolbar {
  height: 70px;
}

.select-css {
  border: 3px solid #ff874b;
  display: inline-block;
  width: 30px;
  height: 30px;
  // background-color: #d4d7d7;
  position: relative;
  &.disabledBtn {
    // 禁用状态
    background-color: #e4e4e4;
    cursor: not-allowed;
  }
}
.select-css::before {
  content: '';
  width: 6px;
  height: 1px;
  background-color: #fff;
  position: absolute;
  top: 10px;
  left: 2px;
  transform: rotate(45deg);
}
.select-css::after {
  content: '';
  width: 11px;
  height: 1px;
  background-color: #fff;
  position: absolute;
  top: 8px;
  left: 5px;
  transform: rotate(-45deg);
}
.goodWork {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  width: 420px;
  .game-good {
    display: flex;
    img {
      width: 150px;
      height: 150px;
      background: url('../assets/images/bg_resbg.png') no-repeat top
        center/150px 150px;
    }
  }

  font-size: 26px;
}
.smallGoodsImg {
  width: 100px;
  height: 100px;
  background: url('../assets/images/bg_resbg.png') no-repeat top center/100px
    100px;
  margin-right: 10px;
}
.good-txt-box {
  margin-left: 10px;
  width: 260px;
}
.small-txt {
  font-size: 24px;
}
.small-txt.orange-txt {
  color: #ff874b;
}

.van-uploader {
  /deep/ .van-uploader__upload {
    width: 120px !important;
    height: 120px !important;
  }
  /deep/ .van-uploader__upload-icon {
    font-size: 50px !important;
  }
}
/deep/ .van-uploader__preview-image {
  width: 120px;
  height: 120px;
}
/deep/ .van-uploader__preview-delete {
  width: 30px;
  height: 30px;
  .van-uploader__preview-delete-icon {
    font-size: 30px;
  }
}
.img-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -120%);
  color: #ff874b;
}
input:disabled {
  background-color: #eee;
  opacity: 1;
  -webkit-opacity: 1;
}

.btn-apply {
  margin-top: 30px;
  width: 300px;
  height: 100px;
  font-size: 34px;
  font-weight: 600;
  border-radius: 5px;
}

.gray {
  background-color: #bebebe;
  color: rgb(88, 88, 88);
}

.orange {
  background-color: #ff6262;
  color: #fff;
}
.placeholder.img {
  font-size: 28px;
}
.cover-box {
  width: 420px;
  .input.img {
    display: flex;
    justify-content: space-between;
    div {
      width: 56px;
      height: 56px;
      background: #ff874b;
      border-radius: 5px;
      color: #fff;
      line-height: 56px;
      font-size: 40px;
      font-weight: 800;
    }
  }
}
.upload-img {
  width: 100px;
  height: 100px;
}
.imgs-box {
  display: flex;
  flex-wrap: wrap;
  width: 420px;
  margin-top: 5px;
  margin-right: 5px;
}
.close-img {
  width: 100px;
  height: 100px;
  position: relative;

  .close-btn {
    width: 30px;
    height: 30px;
    color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgba(255, 135, 75, 0.911);
    line-height: 25px;
    text-align: center;
  }
}
.more {
  border: 1px solid #ccc;
  margin-right: 5px;
  margin-bottom: 5px;
}
.van-loading__text {
  color: #000;
  font-size: 30px;
  font-weight: 600;
}
.uploadImg {
  display: none;
}
.go-email-tips-box {
  position: absolute;
  width: 620px;
  height: 350px;
  background: #fff;
  top: 0;
  bottom: 0;
  border-radius: 10px;
  border: 1px solid #ff874b;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  .btn-close-email {
    background-color: #ff874b;
    color: #fff;
    width: 100px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    border-radius: 5px;
  }
}
.no-ncda-work {
  width: 640px;
  font-size: 24px;
  color: #ff874b;
  margin-top: 30px;
}
</style>
